module.exports = __webpack_public_path__ + "static/media/thumbnail.5d480070.jpg";